import GenericDialog from "../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import {Button, Typography} from "@material-ui/core";
import IconLeft from "@material-ui/icons/ChevronLeft";
import Box from "@material-ui/core/Box";
import CardsWithImages from "./cards-with-images/CardsWithImages";
import DettaglioPianoCard from "./dettaglio-piano-card/DettaglioPianoCard";
import {useSelector} from "react-redux";
import OpzioniGettoniCard from "./opzioni-gettoni-card/OpzioniGettoniCard";
import AssociatedSimsToPlan from "./associated-sims-to-plan/AssociatedSimsToPlan";
import PropTypes from "prop-types";
import DettaglioPlafondShare from "./dettaglio-plafond-share/DettaglioPlafondShare";

const DetailsDialog = (props) => {
    const fetchSimsAssociatedToPlanError = useSelector((state) => state.contrattoDigitaleReducer.simsAssociatedToPlan.error)

    const dialogContent = (
        <Box>
            <Button variant={"text"}
                    onClick={props.handleDialogClose}
                    color={"primary"}
                    startIcon={<IconLeft/>}>Indietro</Button>
            <CardsWithImages planCardsData={props.planCardsData}
                             isPlan={props.arePianoDetails}
                             isPlafondShare={props.isPlafondShare}/>
            <DettaglioPianoCard arePianoDetails={props.arePianoDetails}
                                planName={props.itemName}/>
            {props.isPlafondShare && <DettaglioPlafondShare selectedRow={props.selectedRow}/>}
            {props.arePianoDetails ? <OpzioniGettoniCard/> : null}
            <Box mb='1em'>
                <Typography variant='h6'>{props.arePianoDetails ?
                    'SIM attive associate al piano' :
                    'SIM attive associate all’opzione'}</Typography>
            </Box>
            <AssociatedSimsToPlan arePianoDetails={props.arePianoDetails}
                                  isPlafondShare={props.isPlafondShare}
                                  data={props.planCardsData}
                                  selectedRow={props.selectedRow}
            />
        </Box>
    )

    return (
        <GenericDialog open={props.open}
                       dialogWidth={"lg"}
                       error={fetchSimsAssociatedToPlanError}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogContent={dialogContent}>
            <Typography variant={"h6"}>{props.itemName}</Typography>
        </GenericDialog>
    )
}

DetailsDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    itemName: PropTypes.string,
    planCardsData: PropTypes.shape({
        itemName: PropTypes.string,
        slug: PropTypes.string,
        activationPriceDisplayValue: PropTypes.string.isRequired,
        monthlyPriceDisplayValue: PropTypes.string.isRequired,
        numberOfSimsDisplayValue: PropTypes.string.isRequired,
        tipologia: PropTypes.string.isRequired,
    }).isRequired,
    selectedRow: PropTypes.object.isRequired,
    arePianoDetails: PropTypes.bool.isRequired
}

export default DetailsDialog;
